import { gql } from '@apollo/client';

export const SIGNUP_MUTATION = gql`
  mutation SignupMutation($email: String!, $password: String!) {
    insert_users_one(
      object: { email: $email, password: $password }
      on_conflict: { update_columns: [], constraint: users_email_key }
    ) {
      token
    }
  }
`;
